export enum AppEventEnum {
    ExcluirPergunta,
    SolicitarPerguntas,
    ReceberPerguntas 
}